var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoFilter = function SvgVideoFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.375 1.5a.875.875 0 0 0-.875.875v1.418c0 .232.092.455.256.619l2.707 2.707a.13.13 0 0 1 .037.088v3.418a.375.375 0 0 0 .475.361l2.25-.625A.375.375 0 0 0 7.5 10V7.207q0-.052.037-.088l2.707-2.707a.88.88 0 0 0 .256-.62V2.376a.875.875 0 0 0-.875-.875z"
  })));
};
export default SvgVideoFilter;